var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btns-box"},_vm._l((_vm.newForm),function(item,index){
var _obj;
return _c('p',{key:index,staticClass:"btn",class:{hide: item.isHide},style:(("" + (item.color? 'color:'+item.color:''))),on:{"click":function($event){return _vm.handleClick(index, item)}}},[_c('span',{class:( _obj = {
                iconfont: true
            }, _obj[item.icon] = true, _obj.add = ['icon-add'].includes(item.icon), _obj.del = ['icon-del'].includes(item.icon), _obj )}),_vm._v(_vm._s(item.name)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }